module.exports = __webpack_public_path__ + "media/images/featuredon_mobihealthnews-b2e98df8.png";